export default "<notifier-container></notifier-container>\n<div class=\"content\" [class]=\"currentLang\">\n  <router-outlet></router-outlet>\n</div>\n"